<ng-container *ngIf="!showExport">
  <payarc-page-header title="Webhook Call Logs">
    <button type="button" payarcButton="primary" (click)="exportexcel()">Export</button>
  </payarc-page-header>

  <payarc-search placeholder="Search" [value]="searchText || ''" (valueChange)="onSearch($event)"></payarc-search>

  <payarc-section-card [flush]="true">
    <payarc-table>
      <thead>
        <tr>
          <th [attr.aria-sort]="ariaSort(sortDirection('event_type'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('event_type')">Event Type <payarc-sort-icon [direction]="sortDirection('event_type')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('id'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('id')">ID <payarc-sort-icon [direction]="sortDirection('id')"></payarc-sort-icon></button>
          </th>
          <th [attr.aria-sort]="ariaSort(sortDirection('created_at'))">
            <button type="button" class="pa-th-sort" (click)="setSorting('created_at')">Date <payarc-sort-icon [direction]="sortDirection('created_at')"></payarc-sort-icon></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="loadFlag">
          <tr class="pa-skeleton-row" *ngFor="let r of [1,2,3]">
            <td *ngFor="let c of [1,2,3]"><span class="pa-skeleton-bar"></span></td>
          </tr>
        </ng-container>

        <tr *ngIf="!loadFlag && errorMsg">
          <td class="pa-table__state-cell" colspan="3">
            <payarc-empty-state title="No webhook logs found" [message]="errorMsg"></payarc-empty-state>
          </td>
        </tr>

        <ng-container *ngIf="!loadFlag && !errorMsg">
          <tr *ngFor="let webhook of webhookList.data" tabindex="0" (click)="openWebhookLog($event, webhook)" (keydown.enter)="openWebhookLog($event, webhook)" (keydown.space)="$event.preventDefault(); openWebhookLog($event, webhook)">
            <td class="strong">{{webhook.event_type ? (webhook.event_type | camalizeStr : true).replace('usd', "USD") : '--'}}</td>
            <td class="muted">{{webhook.id}}</td>
            <td class="muted">{{webhook.created_at ? (webhook.created_at | dateFormat: 'MM/dd/yyyy hh:mm') : '--'}}</td>
          </tr>
        </ng-container>
      </tbody>
    </payarc-table>

    <div class="whl-pager-row" *ngIf="!loadFlag && webhookList.data.length > 0 && metadata?.['total']">
      <label class="whl-pager-row__limit">
        Rows per page
        <select class="pa-input" [(ngModel)]="limit" (change)="setUrl()">
          <option *ngFor="let no of limitArray" [value]="no">{{ no }}</option>
        </select>
      </label>
      <payarc-pager
        [rangeLabel]="pagerRangeLabel"
        [pages]="numbers()"
        [currentPage]="metadata?.['current_page']"
        [disablePrev]="!metadata?.['links']?.['previous']"
        [disableNext]="!metadata?.['links']?.['next']"
        (prev)="pagerPrev()"
        (next)="pagerNext()"
        (pageSelect)="pagerSelect($event)"
      ></payarc-pager>
    </div>
  </payarc-section-card>
</ng-container>

<div *ngIf="showExport">
  <app-export-excel [exportExcel]="exportExcel" [serviceName]="exportData" [filterUrl]="filterPostFix" [searchData]="searchText"></app-export-excel>
</div>
